//
// class for date data type
//
// @extends [DataFormatterType]
//
import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';

/**
 * Data formatter for general date types
 * @ignore
 */
export class DataFormatDate extends DataFormatterType
{
	constructor(...args: any[])
	{
		super();
	}

	getName(): string
	{
		return "date";
	}

	/* Return option text to the right of the display value */
	getUnitText(options?: DataFormatterOptions): string
	{
		return "";
	}

	/* Default options for the date formatter */
	initializeOptions(): DataFormatterOptions
	{
		return {
		}
	}

	/**
	 * funtion to format the currently passed data
	 *
	 * @param {object} data data to be formatted
	 * @param {object} options additonal options defined for the datatype
	 * @param {string} path path where the value is being edited
	 * @return {object} data formatted data
	 */
	format(data: any, options: any, path: any)
	{
		if (!data) return "";

		let value = this.unformat(data);
		if (!value) return "";
		return value;
	}

	// Text alignment default
	getAlign(): string
	{
		return "right";
	}

	/**
	 * Format the data for export.  As this is a basic type, we want CSV files
	 * to have the raw number value.
	 *
	 * @param {object} data
	 * @param {object} options
	 * @param {object} refObj
	 */
	formatExport(data: any, options?: DataFormatterOptions, refObj?: any): any
	{
		return DataTools.getNumber(data);
	}

	localFormat(year: number, month: number, day: number)
	{
		return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
	}

	/**
	 * funtion to unformat the currently formatted data
	 * @param {object} data data to be unformatted
	 * @return {object} data unformatted data
	 */
	unformat(data: any, format?: string): string | undefined
	{
		if (!data)
			return '';

		if (data === "")
			return "";

		if (typeof (data) === "string")
		{
			// Look for a yyyy-mm-dd format first
			let match = data.match("([0-9]{4})[\-\/]([0-9]{1,2})[\-\/]([0-9]{1,2})");
			if (match)
			{
				let year = parseInt(match[1], 10);
				let month = parseInt(match[2], 10);
				let day = parseInt(match[3], 10);
				return this.localFormat(year, month, day);
			}
		}

		if (data && typeof (data) === "object" && data.getTime)
		{
			let match = new Date(data).toISOString().match("([0-9]{4})[\-\/]([0-9]{1,2})[\-\/]([0-9]{1,2})T00:00");
			if (match)
			{
				let year = parseInt(match[1], 10);
				let month = parseInt(match[2], 10);
				let day = parseInt(match[3], 10);
				return this.localFormat(year, month, day);
			}
		}

		const m = DataTools.getMoment(data, format);
		if ((m == null))
		{
			return undefined;
		}

		let d = m.toDate();
		let year = d.getFullYear();
		let month = d.getMonth() + 1;
		let day = d.getDate();
		return this.localFormat(year, month, day);
	}

}

export default DataFormatDate;
